export default "__VITE_ASSET__BKJANKwq__"